const tbTasks = {
  table: 'tb_tasks',
  idKey: 'id',

  attrs: [
    'creationDate',
    'lastModifiedDate',
    'deleted'
  ],

  relationships: [    
    {
      type: 'companies',
      key: 'company',
    },
    {
      type: 'toolboxes',
      key: 'toolbox',
    },
    {
      type: 'tasks',
      key: 'task',
    }
  ],
}

export default tbTasks